import axios from 'axios'

const RESOURCE_NAME = '/nivel2'

export default {
  getAll (params) {
    let apiParams = new URLSearchParams(window.location.search).toString()
    if (params) {
      apiParams = Object.entries(params).map(([key, val]) => `${key}=${val}`).join('&')
    }
    if (apiParams) {
      return axios.get(`${RESOURCE_NAME}?${apiParams.toString()}`)
    } else {
      return axios.get(`${RESOURCE_NAME}`)
    }
  },

  get (id) {
    return axios.get(`${RESOURCE_NAME}/${id}`)
  },

  create (data) {
    return axios.post(RESOURCE_NAME, data)
  },

  update (id, data) {
    return axios.post(`${RESOURCE_NAME}/${id}`, data)
  },

  delete (id) {
    return axios.delete(`${RESOURCE_NAME}/${id}`)
  }
}
